/*global exports*/
var SignStream = require('./lib/sign-stream');

var VerifyStream = require('./lib/verify-stream');

var ALGORITHMS = ['HS256', 'HS384', 'HS512', 'RS256', 'RS384', 'RS512', 'PS256', 'PS384', 'PS512', 'ES256', 'ES384', 'ES512'];
exports.ALGORITHMS = ALGORITHMS;
exports.sign = SignStream.sign;
exports.verify = VerifyStream.verify;
exports.decode = VerifyStream.decode;
exports.isValid = VerifyStream.isValid;

exports.createSign = function createSign(opts) {
  return new SignStream(opts);
};

exports.createVerify = function createVerify(opts) {
  return new VerifyStream(opts);
};